export default "__VITE_ASSET__226d7bcf__"